<template>
  <form v-if="order" class="col-md-6 card">
    <div class="form-group row">
      <div class="col">
        <label class="col-form-label">公司</label>
        <div class="form-text">{{getCompanyDisplay(order.company_code)}}</div>
      </div> 

      <div class="col">
        <label class="col-form-label">内部订单号</label>
        <div class="form-text">{{order.order_no}}</div>
      </div> 

      <div class="col">
        <label class="col-form-label">外部订单号</label>
        <div class="form-text">{{order.company_order_no}}</div>
      </div> 
    </div>

    <div class="form-group row">
      <div class="col">
        <label class="col-form-label">订单名</label>
        <div class="form-text">{{order.order_name}}</div>
      </div>
      <div class="col">
        <label class="col-form-label">份数</label>
        <p v-html="renderOrderItems(order)"></p>
      </div>
      <div class="col">
        <label class="col-form-label">快递公司</label>
        <div class="form-text">{{getShipCompanyDisplay(order.ship_company)}}</div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col">
        <label class="col-form-label">其他</label>
        <div class="form-text text-danger">
          <div v-if="order.admin_notes">管理员： {{order.admin_notes}}</div>
          <div v-if="order.user_notes">用户： {{order.user_notes}}</div>
          <div v-if="order.extra_items.length">
            <div v-for="(item, index) in order.extra_items">
              附件{{index + 1}} ：{{item.name}} X {{item.count}}
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <label class="col-form-label">收件人</label>
        <div class="form-text small">
          <div>{{order.consignee_name}}|{{order.consignee_phone}}</div>
          <div>{{order.consignee_address}}</div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import OrderMixin from '@/mixins/order'
import LocalTime from '@/components/_small/LocalTime'

export default {
  props: ['order'],
  mixins: [OrderMixin],
  components: {
    LocalTime
  }
}
</script>